import { render } from "./OrderModal.vue?vue&type=template&id=d22da96c&scoped=true"
import script from "./OrderModal.vue?vue&type=script&lang=js"
export * from "./OrderModal.vue?vue&type=script&lang=js"

import "./OrderModal.vue?vue&type=style&index=0&id=d22da96c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d22da96c"

export default script